import { queryClient } from "@/core/caching/queryClient";
import { logoutStripeConnectSessions } from "@/core/session/stripeConnectSessions";

const STORAGE_KEY_NAME = "repeatmd-admin-app-auth-token";

const credentialListeners = new Set<() => void>();

export const subscribeAuthToken = (onChange: () => void) => {
  credentialListeners.add(onChange);
  const onStorage = (event: StorageEvent) => {
    if (
      event.storageArea === globalThis.localStorage &&
      (event.key === null || event.key === STORAGE_KEY_NAME)
    )
      onChange();
  };
  globalThis.addEventListener("storage", onStorage);
  return () => {
    credentialListeners.delete(onChange);
    globalThis.removeEventListener("storage", onStorage);
  };
};

export const setAuthToken = (token: string) => {
  queryClient.removeQueries({ queryKey: ["business-verification-submission"] });
  globalThis.localStorage.setItem(STORAGE_KEY_NAME, token);
  for (const onChange of credentialListeners) onChange();
};

export const getAuthToken = () => {
  return globalThis.localStorage.getItem(STORAGE_KEY_NAME);
};

export const isAuthorized = () => {
  return !!getAuthToken();
};

export const removeAuthToken = () => {
  globalThis.localStorage.removeItem(STORAGE_KEY_NAME);
  for (const onChange of credentialListeners) onChange();
  logoutStripeConnectSessions();
  queryClient.clear();
};
